import { Model } from "@interfaces/model.interface";

export interface CrmTask extends Model {
	assignedToUserProfileId?: number;
	completedDate?: Date;
	createdByUserProfileId?: number;
	crmOpportunityId?: number;
	description: string;
	dueDate?: Date;
	isCompleted: boolean;
	title: string;
}

export class CrmTask implements CrmTask {
	constructor(data?: Partial<CrmTask>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}
